import { createBrowserHistory } from 'history';

export const history = createBrowserHistory(

);

export const truncate = (str, num) => {
    return str.length > num ? str.substring(0, num) + "..." : str;
}